export default __webpack_public_path__ + "static/media/s_approved.3375ede4.svg";